import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageContainer from 'pages/container';
import TeamsTable from 'components/teams-table';
import LoadingBar from 'components/loading-bar';
import { getPlayersRequest } from 'actions/pages/teams';
import { SEASON_ID } from 'config';

class Teams extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getPlayersRequest(SEASON_ID));
  }

  render() {
    const { app, page } = this.props;
    const { players, requests } = page;
    const { teams } = app;

    let content;

    if (requests.getPlayers.success) {
      if (players) {
        content = (
          <div className="content">
            <TeamsTable teams={teams} players={players} />
          </div>
        );
      } else {
        content = <p className="intro">No players found.</p>;
      }
    } else {
      content = <LoadingBar />;
    }

    return (
      <PageContainer
        className="teams"
        title="Teams"
        subtitle="These teams will fight to win the tournament">
        {content}
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
  page: state.pages.teams,
});

export default connect(mapStateToProps)(Teams);



// WEBPACK FOOTER //
// ./src/pages/teams/teams.js